import Image from 'next/image'
import { IUser } from 'src/types/graphql'
import { extractUsername } from 'src/utils/socialMediaRegex'
import { Maybe } from '../../types/graphql'

export type IconVariants = {
  blue: string
  white: string
  default: string
}

export type SocialMediaItem = {
  name: string
  icon: IconVariants
  href: Maybe<string> | undefined
  size: number
}

const SocialMediaIcons = ({
  primaryColor,
  user
}: {
  primaryColor: string
  user: IUser
}) => {
  const { facebookUrl, instagramUrl, twitterUrl } = user
  const validateSocialMediaUrl = (url: string, prefix: string): string => {
    if (
      typeof url === 'string' &&
      (url.includes('https://') || url.includes('http://'))
    ) {
      return url
    } else {
      return `${prefix}${url}`
    }
  }

  const SOCIAL_MEDIA_ITEMS: SocialMediaItem[] = [
    {
      name: 'facebook',
      icon: {
        blue: '/svgs/facebook-f-blue.svg',
        white: '/svgs/facebook-f-white.svg',
        default: '/svgs/facebook-f-white.svg'
      },
      href:
        facebookUrl &&
        validateSocialMediaUrl(facebookUrl, 'https://www.facebook.com/'),
      size: 16
    },
    {
      name: 'instagram',
      icon: {
        blue: '/svgs/instagram-blue.svg',
        white: '/svgs/instagram-white.svg',
        default: '/svgs/instagram-white.svg'
      },
      href:
        instagramUrl &&
        validateSocialMediaUrl(instagramUrl, 'https://www.instagram.com/'),
      size: 16
    },
    {
      name: 'twitter',
      icon: {
        blue: '/svgs/instagram-blue.svg',
        white: '/svgs/instagram-white.svg',
        default: '/svgs/instagram-white.svg'
      },
      href:
        twitterUrl &&
        validateSocialMediaUrl(twitterUrl, 'https://www.twitter.com/'),
      size: 16
    }
  ]

  const items = SOCIAL_MEDIA_ITEMS.filter((item) => item.href)

  if (items.length === 0) return null

  return (
    <div className="inline-flex flex-wrap gap-2">
      {items.map((item) => {
        const src =
          primaryColor === 'blue'
            ? item.icon.blue
            : primaryColor === 'white'
              ? item.icon.white
              : item.icon.default

        return (
          <a
            target="_blank"
            key={item.name}
            href={item.href!}
            rel="noreferrer"
            className="group inline-flex items-center gap-1.5 rounded-full border border-ink-100/15 bg-cream-200 px-3 py-1.5 transition-colors hover:bg-cream-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"
          >
            <div className="flex size-5 items-center justify-center rounded-full bg-blue-500">
              <Image
                src={src}
                alt={item.name}
                width={item.size}
                height={item.size}
                className="size-3"
              />
            </div>
            <span className="text-xs font-semibold text-ink-700 group-hover:text-blue-800">
              @{extractUsername(item.href!)}
            </span>
          </a>
        )
      })}
    </div>
  )
}

export default SocialMediaIcons
